import { red, green } from '@material-ui/core/colors';
import { createTheme  } from '@material-ui/core/styles';

const fontFamily1 = 'Noto Serif, serif';
const fontFamily2 = 'Noto Sans, sans-serif';
const spacing = (factor) => 10 * factor;//default 8
const fontSpacing = (factor) => 1.25*factor + "rem";//lets us adjust the font spacing factor

var palette = {
    primary: {
        main: '#275daa',
        dark: '#0d2038'
    },
    secondary: {
        main: '#214545'
    },
    tertiary: {
        main: '#412FB3'
    },
    grey: {
        dark: '#666666',
        main: '#999999',
        light: '#ededed'
    },
    danger: {
        main: "#9a0036",
    },
    error: {
        main: red.A400,
        light: '#ffe5e5'
    },
    success: {
        main: green['500'],
        light: "#d4edda"
    },
    background: {
        default: '#fafafd',
    },
    text: {
        primary: "#000",
        secondary: "#595959"
    },
    orange: {
        main: "#f0954e"
    }
};

var typography = {
    fontSize: 16,
    fontFamily: fontFamily2,
    body1: {
        marginTop: "0rem",
        marginBottom: fontSpacing(1),
        fontSize: "1rem"
    },
    body2: {
        fontSize: "1rem",
        marginTop: fontSpacing(0.4)
    },
    listItemText: {
        marginTop: fontSpacing(0.5),
    },
    h1: {
        fontFamily: fontFamily2,
        fontWeight: "bold",
        marginTop: "0rem",
        marginBottom: fontSpacing(1.2),
        fontSize: "2.5rem",
        fontWeight: "700",
        color: palette.primary.dark
    },
    h2: {
        fontFamily: fontFamily2,
        marginTop: fontSpacing(2.2),
        marginBottom: fontSpacing(1.2),
        fontSize: "1.7rem",
        fontWeight: "700",
        color: palette.primary.dark
    },
    subtitle1: {
        fontFamily: fontFamily2,
        marginTop: fontSpacing(0.2),
        marginBottom: fontSpacing(2.2),
        fontSize: "1.3rem"
    },
    h3: {
        fontFamily: fontFamily2,
        fontWeight: "bold",
        marginTop: fontSpacing(1),
        marginBottom: fontSpacing(1.2),
        fontSize: "1.2rem",
        fontWeight: "700"
    },
    h4: {
        fontFamily: fontFamily2,
        fontWeight: "bold",
        marginTop: fontSpacing(0.2),
        marginBottom: fontSpacing(1.2),
        fontSize: "1.1rem"
    }
};


// A custom theme for this app
const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1180,
            xl: 1920,
        },
    },
    typography: typography,
    palette: palette,
    spacing: spacing,
    fontSpacing: fontSpacing
});

theme.fontFamily1 = fontFamily1;
theme.fontFamily2 = fontFamily2;

export default theme;